import classnames from 'classnames';
import { TokenText } from "../../Text/TokenText/TokenText";
import { Text } from "../../Text/Text/Text";
import styles from "./TextPrice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var defaultPropsTextPrice = {
  text: '',
  price: '',
  className: '',
  priceClass: '',
  typog: 'bodycopy',
  typogPriceText: 'bodycopy',
  ariaLabel: ''
};
export var TextPrice = function TextPrice(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? defaultPropsTextPrice.text : _ref$text,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? defaultPropsTextPrice.price : _ref$price,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaultPropsTextPrice.className : _ref$className,
    _ref$priceClass = _ref.priceClass,
    priceClass = _ref$priceClass === void 0 ? defaultPropsTextPrice.priceClass : _ref$priceClass,
    _ref$typog = _ref.typog,
    typog = _ref$typog === void 0 ? defaultPropsTextPrice.typog : _ref$typog,
    _ref$typogPriceText = _ref.typogPriceText,
    typogPriceText = _ref$typogPriceText === void 0 ? defaultPropsTextPrice.typogPriceText : _ref$typogPriceText,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? defaultPropsTextPrice.ariaLabel : _ref$ariaLabel;
  var tokens = {
    '[price:token]': /*#__PURE__*/_jsx(Text, {
      typog: typog,
      childrenInline: true,
      className: classnames(styles.textPrice, priceClass),
      children: price
    })
  };
  var attributes = ariaLabel ? {
    'aria-hidden': 'true'
  } : {};
  return /*#__PURE__*/_jsx(Text, {
    typog: typogPriceText,
    className: className,
    childrenInline: true,
    "aria-label": ariaLabel || undefined,
    children: /*#__PURE__*/_jsx(TokenText, {
      text: text,
      tokens: tokens,
      attributes: attributes
    })
  });
};